import { render } from "./AddCompte.vue?vue&type=template&id=bc5ef044&ts=true"
import script from "./AddCompte.vue?vue&type=script&lang=ts"
export * from "./AddCompte.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__